var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgDecreaseIc = function SvgDecreaseIc(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.67 12v-1.333h1.733L8.936 7.233 6.269 9.9 1.336 4.933 2.269 4l4 4 2.667-2.667 4.4 4.4V8h1.333v4h-4Z",
    fill: "#BC0000"
  })));
};

export default SvgDecreaseIc;